import React from 'react'


export default function Neck1() {
    return (
       
   
      <div className='section_heading'>
        <h1>Kalpataru <span>NeckPain</span> Treatment</h1>
        </div>
    

       
    )
}
